<!--new form design-->
<div class="container-fluid bg-formBg" style="background: linear-gradient(to bottom, #d99f1e, #f8bd23);
">
  <div class="d-flex align-items-center justify-content-center" style="height:100vh;">
    <form  class="form-border desktop-from" [formGroup]="loginForm" style="
    padding: 20px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 5px #fff;" >
      <div class="login-title">Sign in</div>
            <!--<div class="imgcontainer">-->
            <!--  <img src="assets/images/100x.png" style="width: 120px;" alt="" class="logo_size">-->
            <!--</div>-->

      <div class="container mt-4 pb-2">

        <p
          *ngIf="errorMsg"
          class="alert alert-danger m-1 p-1"
        >
          {{ errorMsg }}
        </p>
        <p
          *ngIf="successMsg"
          class="alert alert-success m-1 p-1"
        >
          {{ successMsg }}
        </p>
        <div class="linputOld">
          <!-- <label class="text-uppercase" for="inputName"><span class="material-icons">person</span></label> -->
          <input type="text" formControlName="username" class="form-control" id="inputName"
                 placeholder="Username">
          <!--          <mat-icon _ngcontent-serverapp-c141="" role="img" matsuffix=""-->
          <!--                    class="mat-icon notranslate text-warning material-icons mat-icon-no-color" aria-hidden="true"-->
          <!--                    data-mat-icon-type="font">person_outline-->
          <!--          </mat-icon>-->
          <span
            class="text-danger"
            *ngIf="
                (loginFormControl.username.touched || submitted) &&
                loginFormControl.username.errors?.required">
              Username is required
            </span>
        </div>

        <div class="linputOld">
          <!-- <label class="text-uppercase" for="inputPassword"><span class="material-icons">lock</span></label> -->
          <input type="password" formControlName="password" class="form-control" id="inputPassword"
                 placeholder="Password">
          <span
            class="text-danger"
            *ngIf="
                (loginFormControl.password.touched || submitted) &&
                loginFormControl.password.errors?.required">
              Password is required
            </span>
        </div>
        <div class="text-center mt-4">
          <div>
            <span class="text-dark">Do not have an account? </span>
            <button type="button" class="btn btn-sm button_register text-light" routerLink="/register">Register</button>
          </div>
          <button type="submit" class="btn button_new w-100 d-flex justify-content-center mt-2"
                  (click)="login()"><span class=" d-flex align-items-center mr-1 font-weight-bold" style="width: 100%;
    display: flex !important
;
    flex-direction: column;" >LOGIN
               </span>
                  <i _ngcontent-kal-c44="" class="ml-2 fa fa-sign-in-alt"></i>
            <!--            <mat-icon _ngcontent-serverapp-c141="" role="img" class="mat-icon notranslate material-icons mat-icon-no-color text-white" aria-hidden="true" data-mat-icon-type="font">login</mat-icon>-->
          </button>
          <button type="button" class="btn button_new w-100 d-flex justify-content-center mt-2"
                  (click)="demologin()"><span class=" d-flex align-items-center mr-1 font-weight-bold" style="width: 100%;
    display: flex !important
;
    flex-direction: column;" >LOGIN WITH DEMO ID</span>
     <i _ngcontent-kal-c44="" class="ml-2 fa fa-sign-in-alt"></i>
          </button>
          <p class="text-center mt-2 text-dark">Powered by <span style="color:#ec1f00;">100xwins.com</span></p>
        </div>

      </div>
    </form>
    <!-- <div class="form-border desktop-from login-banner">
      <img style="height: 100%;" src="/assets/images/sl-lc-one-layer-two.png" alt="login-banner">
    </div> -->
  </div>
</div>
